// extracted by mini-css-extract-plugin
export default {"bottomButtonContainer":"styles__bottomButtonContainer___Q3hJw","innerWrapper":"styles__innerWrapper___gRCc3","hideBottomBtn":"styles__hideBottomBtn___HbNtL"};